import { render, staticRenderFns } from "./Atestado.vue?vue&type=template&id=b822e52e&scoped=true&"
import script from "./Atestado.vue?vue&type=script&lang=js&"
export * from "./Atestado.vue?vue&type=script&lang=js&"
import style0 from "./Atestado.vue?vue&type=style&index=0&id=b822e52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b822e52e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VBtn,VIcon,VMain})
